import axios from 'axios'
import moment from 'moment'

export default class ApiManager {
    static calendarLocalDateTime(value) {
        if (value === null || value === undefined) return null

        const timestamp = Number(value)
        const timestampInMilliseconds = timestamp < 10000000000 ? timestamp * 1000 : timestamp

        return moment(timestampInMilliseconds).format('YYYY-MM-DD HH:mm')
    }

    static withBusinessLocalDates(body) {
        const payload = { ...body }

        if (payload.start !== undefined) {
            payload.start_local = this.calendarLocalDateTime(payload.start)
        }

        if (Array.isArray(payload.prestations)) {
            payload.prestations = payload.prestations.map(prestation => ({
                ...prestation,
                start_local: this.calendarLocalDateTime(prestation.start),
                block: Array.isArray(prestation.block)
                    ? prestation.block.map(timestamp => Number(timestamp))
                    : prestation.block,
                block_local: Array.isArray(prestation.block)
                    ? prestation.block.map(timestamp => this.calendarLocalDateTime(timestamp))
                    : null,
            }))
        }

        return payload
    }

    /**
     * Get all possbile staff for calendar filter
     */
    static async getStaffs() {
        return axios.get('/back-office/profil/get/all').then(res => {
            return res.data.map(x => {
                x.type = 'staff'
                x.stringify = JSON.stringify(x)
                return x
            })
        })
    }

    /**
     * Get all possible spaces for calendar filter
     */
    static async getSpaces() {
        return axios.get('/back-office/espace/get/all').then(res => {
            return res.data.map(x => {
                ;(x.cat_type = x.type), (x.type = 'space')
                x.stringify = JSON.stringify(x)
                return x
            })
        })
    }

    /**
     * Search client with paginate + search term
     */
    static async searchClients(limit, page, val) {
        return axios.post('/back-office/user/get/page', { limit, page, pattern: val }).then(res => res.data)
    }

    static async addToCard(product_id, user_id) {
        return axios.post('/back-office/caisse/product/add', { product_id, user_id }).then(res => res.data)
    }

    static async addToCardByOrder(product_id, user_id, order_id) {
        return axios.post('/back-office/caisse/product/by/order/add', { product_id, user_id, order_id }).then(res => res.data)
    }

    /**
     * Get All prestation of category
     */
    static async getAllPrestationOfCategory(categoryId) {
        return axios.get(`/back-office/prestations/category/${categoryId}`).then(res => res.data)
    }

    static async getAllCategories() {
        return axios.get('/back-office/categories/get/all').then(res => res.data)
    }

    static async getPrestationStaffs(prestationId) {
        return axios.get(`/back-office/prestations/${prestationId}/get/staffs`).then(res => res.data)
    }

    static async getPrestationSpaces(prestationId) {
        return axios.get(`/back-office/prestations/${prestationId}/get/spaces`).then(res => res.data)
    }

    /**
     *    Create new client
     */
    static async createClient(first_name, last_name, email, phone, birthday) {
        return axios
            .post(`/back-office/user/add/calendar`, {
                first_name: first_name,
                last_name: last_name,
                email: email,
                phone: phone,
                guest: 0,
                birthday: birthday,
            })
            .then(res => res.data)
    }

    static async loadProductById(user_id) {
        return axios
            .post(`/back-office/order/user`, {
                user_id: user_id,
            })
            .then(res => res.data)
    }

    static async loadProductWithCreatedAt(user_id) {
        return axios
            .post(`/back-office/order/user/createdAT`, {
                user_id: user_id,
            })
            .then(res => res.data)
    }

    static async ressort(order_item_id) {
        return axios.get(`/back-office/order/reossort/${order_item_id}`)
    }

    static async createBooking(body) {
        return axios.post('/back-office/prestations/create/booking', this.withBusinessLocalDates(body)).then(res => res.data)
    }

    static async changeTimeSlot(body, id) {
        return axios.post(`/back-office/prestation/change/timeslot/${id}`, this.withBusinessLocalDates(body)).then(res => res.data)
    }

    // Remplace une prestation existante (changeBooking)
    static async editPrestaBooking(body, id) {
        return axios.post(`/back-office/prestations/change/booking/${id}`, this.withBusinessLocalDates(body)).then(res => res.data)
    }

    // Ajoute une prestation à un booking existant (appendBooking)
    static async appendPrestaBooking(body, id) {
        return axios.post(`/back-office/prestations/append/booking/${id}`, this.withBusinessLocalDates(body)).then(res => res.data)
    }

    static async getTimeslotInfo(id) {
        return axios.get(`/back-office/prestations/get/info/timeslot/${id}`).then(res => res.data)
    }

    static async changeBookingStatus(id, status) {
        return axios.post(`/back-office/prestation/change/booking/status/${id}`, { status }).then(res => res.data)
    }

    /**
     * Get all timeslot on booking
     */
    static async getAllTimeSlotOfBooking(id) {
        return axios.get(`/back-office/prestation/get/timeslots/booking/${id}`).then(res => res.data)
    }

    static async getClientFromArray(ids) {
        return axios.post(`/back-office/user/get/user/by/array`, { users: ids }).then(res => res.data)
    }

    static async upSertPreset(data) {
        return axios.post(`/back-office/planning/create/preset`, { data: data }).then(res => res.data)
    }

    static async encaisser(id, codes, selectVoucherItems) {
        return axios.post(`/back-office/prestation/add/booking/basket/${id}`, {
            codes: codes,
            selectVoucherItems: selectVoucherItems,
        })
    }

    static async addVoucherBasket(id, item) {
        return axios.post(`/back-office/prestation/add/voucher/basket/${id}`, { item: item })
    }

    static async removeVoucherBasket(id, item) {
        return axios.post(`/back-office/prestation/remove/voucher/basket/${id}`, { item: item })
    }

    static async getselectedVoucherItems(id) {
        return axios.get(`/back-office/prestation/get/voucher/basket/${id}`)
    }

    static async getPromoCode() {
        return axios.post(`/back-office/promotion/get/code/booking`)
    }
    static async getCurrentPromoCode(booking) {
        return axios.get(`/back-office/promotion/get/code/order/${booking}`)
    }

    static async appendPromoCode(bookingId, id) {
        return axios.post(`/back-office/promotion/add/code/order/${bookingId}`, { code: id })
    }

    static async deletePromoCode(bookingId, id) {
        return axios.post(`/back-office/promotion/delete/code/order/${bookingId}`, { code: id })
    }

    static async addPromoCode(promoCodeEntered, remainPrice) {
        return axios.get(`/back-office/promotion/check-code-validity`, {
            params: { code: promoCodeEntered, remainPrice: remainPrice },
        })
    }

    static async account(id, codes) {
        return axios.post(`/back-office/prestation/add/booking/basket/account/${id}`, { codes: codes })
    }

    static async deleteTimeSlotOfBooking(id) {
        return axios.get(`/back-office/prestations/delete/timeslot/${id}`).then(res => res.data)
    }

    static async deleteBooking(id) {
        return axios.get(`/back-office/prestations/delete/booking/${id}`).then(res => res.data)
    }

    static async updateBookingNote(id, note) {
        return axios
            .post(`/back-office/planning/booking/${id}/note`, {
                note,
            })
            .then(res => res.data)
    }

    static async updateTimeslotNote(id, note) {
        return axios
            .post(`/back-office/planning/timeslot/${id}/note`, {
                note,
            })
            .then(res => res.data)
    }

    static async changeLockStatusOfBooking(id, isLocked) {
        return axios
            .post(`/back-office/planning/booking/${id}/changelockStateOfBooking`, {
                lock: isLocked,
            })
            .then(res => res.data)
    }

    /** Workshop sessions overlapping the displayed days (unix seconds, UTC midnight). */
    static async getWorkshopSessions(days) {
        if (!days || days.length === 0) return []
        const start = Math.min(...days) - 86400
        const end = Math.max(...days) + 2 * 86400
        return axios
            .get(`/back-office/ateliers/planning`, { params: { start, end } })
            .then(res => res.data)
            .catch(() => [])
    }

    static async getAllTimeslotPack(days, staffs, spaces, phantom) {
        return axios
            .post(`/back-office/prestations/get/day/space/staff`, {
                days: days,
                staffs: staffs,
                spaces: spaces,
                phantom: phantom,
            })
            .then(res => res.data)
    }

    static async updateTimeslot(
        timeslotId,
        userid,
        start,
        spaceId,
        staffIds,
        first_name,
        last_name,
        enableBlock,
        prepa_time,
        presta_time,
        cleanning_time,
        range,
        blockIncludeSpace,
        blockIncludeStaff,
        rebooking
    ) {
        return axios.post(`/back-office/prestation/change/timeslot/${timeslotId}`, this.withBusinessLocalDates({
            user_id: userid,
            start: start,
            space: spaceId,
            staffs_id: staffIds,
            first_name: first_name,
            last_name: last_name,
            enableBlock: enableBlock,
            prepa_time: parseInt(prepa_time || '0'),
            presta_time: parseInt(presta_time || '0'),
            cleanning_time: parseInt(cleanning_time),
            block: range,
            blockIncludeSpace: blockIncludeSpace,
            blockIncludeStaff: blockIncludeStaff,
            rebooking: rebooking,
        }))
    }
    static async avaibilitySalle($start, $id_prestation, $establishment_id, $numberUser) {
        return axios.post(`/api/check/avaibility/salle`, {
            start: $start,
            id_prestation: $id_prestation,
            establishment_id: $establishment_id,
            numberUser: $numberUser,
        })
    }

    static async getRoomAvaibleSpace(start, end) {
        return axios.post(`/back-office/prestation/get/space/available/nbr`, { start: start, end: end })
    }

    static async getPossibleTreatment(user_id, prestations_id) {
        return axios.post(`/back-office/treatments_customers/${user_id}/getTreatmentOfUser`, { prestations_id: prestations_id })
    }

    static async getUsedTreatment(user_id, prestations_id) {
        return axios.post(`/back-office/treatments_customers/${user_id}/getTreatmentUsed`, { prestations_id: prestations_id })
    }

    static async getPossibleSeries(user_id, prestations_id) {
        return axios.post(`/back-office/series_customers/${user_id}/getSerieOfUser`, { prestations_id: prestations_id })
    }

    static async getUsedSeries(user_id, prestations_id) {
        return axios.post(`/back-office/series_customers/${user_id}/getSerieUsed`, { prestations_id: prestations_id })
    }

    static async unlinkSerie(userId, serieName, timeSlotId) {
        return axios.post(`/back-office/series_customers/delete_prestation_user`, {
            userId: userId,
            serieName: serieName,
            timeSlotId: timeSlotId,
        })
    }

    static async loadCreneauPossibility(body) {
        return axios.post(`/back-office/prestations/getAvailableTimeSlot`, body)
    }

    static async loadAlert(bookingId, typeId) {
        return axios.post(`/back-office/get/alert/user/type`, {
            booking_id: bookingId,
            alert_type: typeId,
        })
    }

    static async loadAlertUser(userId, typeId) {
        return axios.post(`/back-office/get/alert/user/type2`, {
            user_id: userId,
            alert_type: typeId,
        })
    }

    static async loadBookingLogs(id) {
        return axios.get(`/back-office/prestations/getBookingLogs/${id}`).then(res => {
            return res.data
        })
    }

    static async getOptionsByBooking(bookingId) {
        return axios.get(`/back-office/prestations/getOption/booking/${bookingId}`).then(res => {
            return res.data
        })
    }
    //   static async getAnswersByBooking(bookingId) {
    //     return axios.get(`/back-office/prestations/getAnswers/booking/${bookingId}`).then(res => {
    //       return res.data
    //     })
    //   }
    static async getBookingAnswers(bookingId) {
        return axios.get(`/back-office/booking/${bookingId}/questions/answers`).then(res => {
            return res.data
        })
    }
    static async getProductsByBooking(bookingId) {
        return axios.get(`/back-office/prestations/getProducts/booking/${bookingId}`).then(res => {
            return res.data
        })
    }
    static async loadWorkingTime(staffIds, space_ids, days) {
        if (!staffIds.length && !space_ids.length) return
        days.sort((a, b) => a - b)

        return axios
            .post(`/back-office/planning/staffs/search`, {
                staff_id: staffIds,
                space_id: space_ids,
                start: days[0],
                end:
                    moment(days[days.length - 1] * 1000)
                        .utc()
                        .set({ hour: 22, minute: 0, second: 0, millisecond: 0 })
                        .valueOf() / 1000,
            })
            .then(res => res.data)
    }

    static async loadExceptionsTime(days) {
        days.sort((a, b) => a - b)

        return axios
            .post(`/back-office/planning/establishment/search`, {
                start: days[0],
                end:
                    moment(days[days.length - 1] * 1000)
                        .utc()
                        .set({ hour: 22, minute: 0, second: 0, millisecond: 0 })
                        .valueOf() / 1000,
            })
            .then(res => res.data)
    }

    static async getLockerBooking(bookingId) {
        return axios.get(`/back-office/casiers/get/booking/${bookingId}`).then(res => {
            return res.data
        })
    }

    static async deleteLockerBooking(bookingId, lockerId) {
        return axios
            .post(`/back-office/casiers/delete/booking/${bookingId}`, {
                locker_id: lockerId,
            })
            .then(res => {
                return res.data
            })
    }

    static async addLockerBooking(bookingId, lockerId) {
        return axios
            .post(`/back-office/casiers/add/booking/${bookingId}`, {
                locker_id: lockerId,
            })
            .then(res => {
                return res.data
            })
    }

    static async getAllOptionsOfBooking(bookingId) {
        return axios.get(`/back-office/get/all/booking/${bookingId}/options`).then(res => {
            return res.data
        })
    }
    static async getAllProducts(bookingId) {
        return axios.get(`/back-office/get/all/booking/${bookingId}/products`).then(res => {
            return res.data
        })
    }

    static async addOptionBooking(bookingId, prestation_id, option, timeslot_id) {
        return axios
            .post(`/back-office/add/booking/${bookingId}/options`, {
                prestation_id: prestation_id,
                option: option,
                timeslot_id: timeslot_id,
            })
            .then(res => {
                return res.data
            })
    }

    static async removeOptionBooking(bookingId, prestation_id, option, timeslot_id) {
        return axios
            .post(`/back-office/remove/booking/${bookingId}/options`, { prestation_id: prestation_id, option: option })
            .then(res => {
                return res.data
            })
    }

    static async addProductBooking(bookingId, prestation_id, product, timeslot_id) {
        return axios
            .post(`/back-office/add/booking/${bookingId}/products`, {
                prestation_id: prestation_id,
                product: product,
                timeslot_id: timeslot_id,
            })
            .then(res => {
                return res.data
            })
    }

    static async removeProductBooking(bookingId, prestation_id, product, timeslot_id) {
        return axios
            .post(`/back-office/remove/booking/${bookingId}/products`, { prestation_id: prestation_id, product: product })
            .then(res => {
                return res.data
            })
    }

    static async getAllAnswers(bookingId) {
        return axios.get(`/back-office/get/all/booking/${bookingId}/answers`).then(res => {
            return res.data
        })
    }

    static async editAnswerBooking(
        bookingId,
        prestation_id,
        question,
        answer,
        multiple = null,
        mult_answer = null,
        timeslot_id,
        answer_id = null
    ) {
        return axios
            .post(`/back-office/edit/booking/${bookingId}/answers`, {
                prestation_id: prestation_id,
                question: question,
                answer: answer,
                answer_id: answer_id,
                multiple: multiple,
                mult_answer: mult_answer,
                timeslot_id: timeslot_id,
            })
            .then(res => {
                return res.data
            })
    }

    static async getAllLocker() {
        return axios.get(`/back-office/casiers/get/all`).then(res => {
            return res.data
        })
    }

    /**
     * Get All packages
     */
    static async getAllPackages() {
        return axios.get('/back-office/forfaits/get/all').then(res => res.data)
    }

    static async getEstaInfo(day) {
        return axios.get('/back-office/etablissement/get/info/by/day', { day: day }).then(res => res.data)
    }

    static async createPlanningExceptionCalendar(user_id, start, end, status, text, days = [], repeat) {
        return axios
            .post('/back-office/staff/planning/exception/create/calendar', {
                user_id: user_id,
                start: start,
                end: end,
                start_local: this.calendarLocalDateTime(start),
                end_local: this.calendarLocalDateTime(end),
                status: status,
                days: days,
                text: text,
                repeat: repeat
                    ? repeat.map(date => ({
                          ...date,
                          start_local: this.calendarLocalDateTime(date.start),
                          end_local: this.calendarLocalDateTime(date.end),
                      }))
                    : repeat,
            })
            .then(res => res.data)
    }
    static async loadBookingById(booking) {
        return axios.get(`/back-office/get/booking/by/id/${booking}`).then(res => res.data)
    }
    static async createPlanningExceptionCalendarSpace(space_id, start, end, status, text, repeat) {
        return axios
            .post('/back-office/staff/planning/exception/create/calendar/space', {
                space_id: space_id,
                start: start,
                end: end,
                start_local: this.calendarLocalDateTime(start),
                end_local: this.calendarLocalDateTime(end),
                status: status,
                text: text,
                repeat: repeat
                    ? repeat.map(date => ({
                          ...date,
                          start_local: this.calendarLocalDateTime(date.start),
                          end_local: this.calendarLocalDateTime(date.end),
                      }))
                    : repeat,
            })
            .then(res => res.data)
    }
    static async deletePlanningExceptionCalendarSpace(exception_id, includeRecDel) {
        return axios
            .post(`/back-office/staff/planning/exception/delete/calendar/space/${exception_id}`, { includeReq: includeRecDel })
            .then(res => res.data)
    }
    static async deletePlanningExceptionCalendar(exception_id, includeRecDel) {
        return axios
            .post(`/back-office/staff/planning/exception/delete/calendar/${exception_id}`, { includeReq: includeRecDel })
            .then(res => res.data)
    }
    static async editExceptionCalendar(exception_id, start, end, withRec, textIndispo) {
        return axios
            .post(`/back-office/staff/planning/exception/edit/calendar/${exception_id}`, {
                start: start,
                end: end,
                start_local: this.calendarLocalDateTime(start),
                end_local: this.calendarLocalDateTime(end),
                withRec: withRec,
                textIndispo: textIndispo,
            })
            .then(res => res.data)
    }
    static async editExceptionSpaceCalendar(exception_id, start, end, withRec) {
        return axios
            .post(`/back-office/staff/planning/exception/edit/calendar/space/${exception_id}`, {
                start: start,
                end: end,
                start_local: this.calendarLocalDateTime(start),
                end_local: this.calendarLocalDateTime(end),
                withRec: withRec,
            })
            .then(res => res.data)
    }
    static async getCancelPrice(bookingId) {
        return axios.get(`/back-office/prestations/calendrier/cancelPrice/booking/${bookingId}`).then(res => res.data)
    }
    static async getAbsentCancelPrice(bookingId) {
        return axios.get(`/back-office/prestations/calendrier/cancelAbsentPrice/booking/${bookingId}`).then(res => res.data)
    }
    static async cancelBooking(bookingId, userId, repay = false, cancelBooking = false) {
        return axios
            .get(
                `/back-office/prestations/calendrier/cancel/booking/${bookingId}/${userId}?repay=${repay}&cancelBooking=${cancelBooking}`
            )
            .then(res => res.data)
    }

    static async absentCancelBooking(bookingId, userId, repay = false, cancelBooking = false) {
        return axios
            .get(
                `/back-office/prestations/calendrier/cancel/absence/booking/${bookingId}/${userId}?repay=${repay}&cancelBooking=${cancelBooking}`
            )
            .then(res => res.data)
    }

    static async getEstaInfoForDays(day) {
        return axios.post('/back-office/etablissement/get/info/by/days', { days: day }).then(res => res.data)
    }
    static async getOrderByBooking(bookingId) {
        return axios.get(`/back-office/prestations/get/order/booking/${bookingId}`).then(res => res.data)
    }
    static async getAvailableStaffAndSpace(prestation_id, start, end, target, nb_user = null) {
        return axios
            .post(`/back-office/prestations/get/available/space/staff/${prestation_id}`, {
                start: start,
                end: end,
                nb_user: nb_user,
                target: target,
            })
            .then(res => res.data)
            .catch(err => console.error(err))
    }

    static async editLunchStaff(id, start, end) {
        return axios
            .post(`/back-office/staff/edit/lunch/${id}`, {
                lunch_start: start,
                lunch_end: end,
            })
            .then(res => res.data)
            .catch(err => console.error(err))
    }

    static async deleteLunchStaff(id) {
        return axios.get(`/back-office/staff/delete/lunch/${parseInt(id)}`).then(res => res.data)
    }

    static async getPresets() {
        return axios
            .get(`/back-office/planning/get/preset`)
            .then(res => (res && res.data.data ? JSON.parse(res.data.data.replace('\\"', '"'))?.items : []))
    }

    static async checkPackageAvailableWithThisPrestations(prestations) {
        return axios.post(`/back-office/package/get/available/by/prestations`, { prestations: prestations }).then(res => res.data)
    }

    static async getLastDiagnostic(bookingRowId) {
        return axios.get(`/back-office/diagnostic/check/create/update/${bookingRowId}`).then(res => res.data)
    }

    static async getOrderWithItemsAndUser(orderId) {
        return axios.get(`/back-office/caisse/loadOrderWithItemsAndUser/${orderId}`).then(res => res.data)
    }

    static async mergeOrders(orders) {
        let orderId = orders[0].order_id
        orders.splice(0, 1)
        return axios
            .post(`/back-office/order/merge/${orderId}`, {
                with: orders,
            })
            .then(res => res.data)
    }

    static async checkAvailabilityPrestations(prestations, dates) {
        const prestationIds = prestations.map(item => item.id)
        console.log('Prestation:', prestationIds)
        return axios
            .post(`/back-office/prestations/check/availablility`, {
                prestations: prestationIds,
                dates: dates,
            })
            .then(res => {
                console.log('res:', res)
                return res && res.data
            })
            .catch(error => {
                // console.log('Error:', err)
                // return []
                const normalizedError = {
                    success: false,
                    status: error.response?.status ?? null,
                    message:
                        error.response?.data?.message ||      // API error message
                        error.message ||                       // Axios or JS error
                        "An unknown error occurred.",
                    details: error.response?.data ?? null,      // Full backend payload if available
                    axiosError: {
                        url: error.config?.url,
                        method: error.config?.method,
                        payload: error.config?.data,
                    },
                };
                // Log improved, readable error information
                console.error(
                    "%c[Availability Check Error]",
                    "color: red; font-weight: bold;",
                    normalizedError
                );
                return normalizedError;
            })
    }

    static async checkAvailabilityPrestationsFO(prestations, dates) {
        const prestationIds = prestations.map(item => item.id)

        return axios
            .post(`/prestations/check/availablility`, {
                prestations: prestationIds,
                dates: dates,
            })
            .then(res => {
                return res && res.data
            })
            .catch(err => {
                console.log('Error:', err)
                return []
            })
    }
}
